export const breakpointValues = {
  xs: 0,
  sm: 480,
  md: 820,
  lg: 1280,
  xl: 1536
};
